import React, { useState, useEffect } from 'react';
import Card from './Cards/Card';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext'; // Import Language Context

// Utility function to preload images
const preloadImages = (imageUrls) => {
  imageUrls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};

const LatestItemsSection = ({ title, items, linkPath, linkText, hideReadMoreForCategories = [] }) => {
  const [visibleCount, setVisibleCount] = useState(6);
  const { language } = useLanguage();

  useEffect(() => {
    if (items.length > 0) {
      const imageUrls = items.map((item) => item.imgSrc);
      preloadImages(imageUrls);
    }
  }, [items]);

  const handleViewMore = () => {
    setVisibleCount((prevCount) => prevCount + 3);
  };

  const handleDownload = (downloadLink, title) => {
    const anchor = document.createElement('a');
    anchor.href = downloadLink;
    anchor.download = ''; // Triggers download
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  return (
    <section className="container mx-auto my-12 px-4" aria-labelledby={`${title}-section-title`}>
      <h2 id={`${title}-section-title`} className="text-2xl font-bold mb-6" tabIndex="0">
        {title}
      </h2>

      <div
        className={`grid gap-8 ${
          items.length === 1
            ? 'justify-center'
            : items.length === 2
            ? 'grid-cols-1 md:grid-cols-2 justify-center'
            : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3'
        }`}
      >

      {items.slice(0, visibleCount).map((item) => (
        <div
          key={item.id}
          className={`flex justify-center ${
            items.length === 1 ? 'w-full md:w-1/2 lg:w-1/3' : 'w-full'
          }`}
        >
          <Card
            id={item.id}
            title={item.title}
            description={item.description}
            imgSrc={item.imgSrc}
            imgAlt={item.imgAlt || `Ilustrimi për ${item.title}`}
            linkText={
              item.category === 'studies'
                ? null // Hide "Shiko më shumë" for studies
                : hideReadMoreForCategories.includes(item.category)
                ? ''
                : item.linkText || 'Lexo më shumë'
            }
            audioSrc={item.audioSrc}
            linkPath={item.category === 'studies' ? null : item.linkPath} // Disable link for studies
            category={item.category}
            aria-label={`Karta për ${item.title}`}
          >
            {/* Conditionally add the download button for studies */}
            {item.category === 'studies' && (
              <div className="mt-4 flex justify-center">
                <button
                  onClick={() => handleDownload(item.docSrc, item.title)}
                  className="btn-custom"
                  aria-label={language === 'Shqip' ? `Shkarko studimin për ${item.title}` : `Download study for ${item.title}`}
                >
                  {language === 'Shqip' ? 'Shkarko' : 'Download'}
                </button>
              </div>
            )}
          </Card>
        </div>
      ))}


      </div>

      {/* "View More" button (if there are more items to show) */}
      {visibleCount < items.length && (
        <div className="flex justify-center mt-8">
          <button
            onClick={handleViewMore}
            className="btn-custom"
            aria-label={language === 'Shqip' ? `Shiko më shumë ${title}` : `Show more for ${title}`}
          >
            {language === 'Shqip' ? 'Shiko më shumë' : 'Show more'}
          </button>
        </div>
      )}

      {/* "View All" button that is always displayed */}
      <div className="flex justify-center mt-8">
        <Link to={linkPath} className="btn-custom" aria-label={`Shiko të gjitha ${title}`}>
          {linkText}
        </Link>
      </div>
    </section>
  );
};

export default LatestItemsSection;
